import React from 'react';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import rrulePlugin from '@fullcalendar/rrule'
import { Box, Container, Button, Menu, MenuItem, ButtonGroup, Popover, List, ListItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import AddEvent from './AddEvent';
import EditEvent from './EditEvent';
import CalApiContext from './CalApiContext';

const Calendar = () => {
 
  //state variables
  const [calData, setCalData] = React.useState([])
  const [rawDbData, setRawDbData] = React.useState([])
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [datePopoverAnchorEl, setDatePopoverAnchorEl] = React.useState(null);
  const [eventPopoverAnchorEl, setEventPopoverAnchorEl] = React.useState(null);
  const [editPopoverAnchorEl, setEditPopoverAnchorEl] = React.useState(null);
  const [dateClickData, setDateClickData] = React.useState('');
  const [eventClickData, setEventClickData] = React.useState([])
  const [eventClickObj, setEventClickObj] = React.useState({})
  const [orgList, setOrgList] = React.useState([])
  const [currentOrg, setCurrentOrg] = React.useState('')
  const { addCalendarContext, setActiveDate } = React.useContext(CalApiContext)
  let calendarRef = React.useRef()
  
  //material ui styling
  const useStyles = makeStyles((theme) => ({
    typography: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    paper: {
      padding: theme.spacing(1)
    },
  }));
  const classes = useStyles();
  
  const datePopoverOpen = Boolean(datePopoverAnchorEl)
  const eventPopoverOpen = Boolean(eventPopoverAnchorEl)
  const editPopoverOpen = Boolean(editPopoverAnchorEl)

  //fetch data from db
  React.useEffect(()=>{
     const getInitialData = async () => {
      let url = `https://api.event-calendar.oneilgordon.dev/getAllCalendarData`
      let res = await fetch(url)
      let rawData = await res.json()
      
      let rawOrgNames = []
      rawData.forEach(element => {
        rawOrgNames.push(element.orgName)
      })
   
      let initialCalData = rawData[0].events
      let initialOrgName = rawData[0].orgName
      setCalData([...initialCalData])
      setCurrentOrg(initialOrgName)
      setOrgList([...rawOrgNames])
      setRawDbData([...rawData])
    }

    getInitialData()
  },[])

  //refetch data when calData changes
  React.useEffect(()=>{
    console.log(calData)
    const updateAllRawData = async () => {
     let url = `https://api.event-calendar.oneilgordon.dev/getAllCalendarData`
     let res = await fetch(url)
     let rawData = await res.json()
     
     let rawOrgNames = []
     rawData.forEach(element => {
       rawOrgNames.push(element.orgName)
     })
  
     setOrgList([...rawOrgNames])
     setRawDbData([...rawData])
   }

   updateAllRawData()
 },[calData])

 //adds calendar ref to context
  React.useEffect(()=>{
    addCalendarContext(calendarRef)
    setActiveDate(calendarRef.current.getApi().view.title)
  }, [addCalendarContext, setActiveDate])

  //removes selected event from database
  const deleteEvent = async () => {
    let url = 'https://api.event-calendar.oneilgordon.dev/deleteEvent'
    console.log('delete event')
    let res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        eventOrgName: currentOrg,
        title: eventClickObj.title,
        start: eventClickObj.start,
        end: eventClickObj.end
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    
    let resData = await res.json()
    console.log('delete event server response data below')
    console.log(resData.events)
    setCalData(resData.events)
    setEventPopoverAnchorEl(null)
  }

  //populates all calendars in dropdown menu
  const getCalMenuData = (orgListItem) => {
    rawDbData.forEach(element => {
      if (element.orgName === orgListItem){
        setCurrentOrg(orgListItem)
        let eventArray = []
        eventArray = element.events
        setCalData([...eventArray])
      }
    })
    setMenuAnchorEl(null)
  }  
  
  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  }

  const handleDateClick = (event) => {
    setDateClickData(event.dateStr)
    setDatePopoverAnchorEl(event.dayEl)
    console.log(calData)
  }

  const handleDatePopoverClose = () => {
    setDatePopoverAnchorEl(null);
  };
  
  //creates gets event details from full calendar event object
  const handleEventClick = (event) => {
    setEventClickObj(event.event)
    setEventPopoverAnchorEl(event.el)
    //converts date to something human readable
    const options = { 
      weekday: 'short', 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    };
    const eventData = [event.event.title, new Date(event.event.startStr).toLocaleDateString(undefined, options)]
    setEventClickData([...eventData])
  }

  const handleEventPopoverClose = () => {
    setEventPopoverAnchorEl(null);
  };
  

  const handleEditClick = (event) => {
    console.log(eventClickObj)
    setEditPopoverAnchorEl(event.currentTarget)
    setEventPopoverAnchorEl(null)
  }

  const handleEditPopoverClose = () => {
    setEditPopoverAnchorEl(null)
  }
  
  
  return (
    <Box pt={1} pb={0}>
        <Container maxWidth='xl'>
        <FullCalendar
            ref={calendarRef}
            plugins = {[dayGridPlugin, interactionPlugin, rrulePlugin]}
            initialView = 'dayGridMonth'
            height = '86vh'
            dateClick = {handleDateClick}
            eventClick = {handleEventClick}
            events = {calData}
            headerToolbar ={false}
        />

        <ButtonGroup
          variant='text'
          color='primary'
          araia-aria-label='text primary button group'
        >
          <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleMenuClick}>Select Calendar</Button>
          <Button>You are viewing the Calendar for {currentOrg}</Button>
        </ButtonGroup>
        <Menu
          id="simple-menu"
          anchorEl={menuAnchorEl}
          keepMounted
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
        >
          
            {orgList.map((item, index) => {
              return (
              <MenuItem
                key={index}
                onClick={()=>getCalMenuData(item)}
              > 
                {item} 
              </MenuItem>
              )
            })}
          
        </Menu>
        
        <Popover
          id='add-event-popover'
          open={datePopoverOpen}
          anchorEl={datePopoverAnchorEl}
          onClose={handleDatePopoverClose}
          anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
          }}
          transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
          }}
        >
            <AddEvent
              popoverEl={datePopoverAnchorEl}
              setDatePopoverAnchorEl={setDatePopoverAnchorEl}
              dateClickData={dateClickData}
              currentOrg={currentOrg}
              setCurrentOrg={setCurrentOrg}
              calData={calData}
              setCalData={setCalData}
              
            />

        </Popover>

        <Popover
          id='edit-event-popover'
          open={editPopoverOpen}
          anchorEl={editPopoverAnchorEl}
          onClose={handleEditPopoverClose}
          anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
          }}
          transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
          }}
        >
            <EditEvent
              popoverEl={editPopoverAnchorEl}
              setEditPopoverAnchorEl={setEditPopoverAnchorEl}
              dateClickData={dateClickData}
              currentOrg={currentOrg}
              setCurrentOrg={setCurrentOrg}
              calData={calData}
              setCalData={setCalData}
              eventClickObj={eventClickObj}
              
            />

        </Popover>  

        <Popover
          id='event-click-popover'
          open={eventPopoverOpen}
          anchorEl={eventPopoverAnchorEl}
          onClose={handleEventPopoverClose}
          anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          }}
          transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
          }}
        >
            <Box>
            <List>
              {eventClickData.map((item, index) => {
                  return <ListItem key={index}>{item}</ListItem>     
              })}

            </List>
            <ButtonGroup 
              fullWidth
              variant='contained'
              color='primary'
              >
              <Button onClick={handleEditClick}>Edit</Button>
              <Button color='secondary'onClick={deleteEvent}>Delete</Button>
            </ButtonGroup>
            </Box>
        </Popover>
        </Container> 
    </Box>
  );
}
export default Calendar;